import { render, staticRenderFns } from "./ContractExtensionEdit.vue?vue&type=template&id=cffd8052&"
import script from "./ContractExtensionEdit.vue?vue&type=script&lang=js&"
export * from "./ContractExtensionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports